export function mergeDuplicates(list) {
  let merged = []
  list.map((elementA) => {
    let found = merged.find((elementB) => elementB.id == elementA.id)
    if (!found) {
      merged.push(elementA)
    } else {
      found.currency2 = elementA.currency
    }
  })

  return merged
}
